import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectAiModels = createSelector(getSystem, ({ aiModels }) => aiModels);

export const toAiModelOption = model => ({
  name: model.displayName,
  value: model.id,
  provider: model.provider,
  supportsReasoning: model.supportsReasoning ?? false,
  sizeClass: model.sizeClass ?? null,
  costTier: model.costTier ?? null,
  contextLength: model.contextLength ?? null,
  recommendedRoles: model.recommendedRoles ?? null,
  recommendedRolesIsAdminOverride: model.recommendedRolesIsAdminOverride ?? false,
});

export const selectAiModelsOptions = createSelector(selectAiModels, aiModels =>
  aiModels.map(toAiModelOption),
);

export const selectAiModelProviderOptions = createSelector(selectAiModels, aiModels => {
  const uniqueProviders = Array.from(new Set(aiModels.map(({ provider }) => provider)));

  return uniqueProviders.map(provider => ({ name: provider, value: provider }));
});
